import PropTypes from 'prop-types';
import React from 'react';

export default class extends React.Component {
    static displayName = 'InfoSvg';

    static propTypes = {
        className: PropTypes.string
    };

    static defaultProps = {
        className: ''
    };

    render() {
        const { className } = this.props;

        return (
            <svg viewBox="1.5 1.5 18 18" width="18px" height="18px" preserveAspectRatio="xMidYMid" className={className}>
                <g><circle cx="10.5" cy="10.5" r="8" /><path fillRule="evenodd" d="M10.5 19.5a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9zm-8-9c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8zm10 5h-4l1-2v-3h-1l1-2h2v5l1 2zm-3-10h2v2h-2v-2z" /></g>
            </svg>
        );
    }
}
